import Vue from 'vue'
import Router from 'vue-router'
import ProductList from '@/views/product/list'
import ShoppingCart from '@/views/shoppingCart/index'
import AddressList from '@/views/shoppingCart/addressList'
import AddressEdit from '@/views/shoppingCart/addressEdit'
import OrderList from '@/views/order/list'
import userCenter from '@/views/userCenter/index'

Vue.use(Router)

// push跳转到当前链接会报错，添加这个就不报错了(捕获异常不处理。。)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

/* Layout */
import Layout from '@/layout/index'
import AccountLayout from '@/layout/account'

export default new Router({
  routes: [
    {
      path: '/',
      component: Layout,
      children: [
        {
          path: '',
          component: ProductList,
          name: 'ProductList',
        },
      ],
    },
    {
      path: '/shoppingcart',
      component: Layout,
      children: [
        {
          path: '',
          component: ShoppingCart,
          name: 'ShoppingCart',
        },
      ],
    },
    {
      path: '/address',
      component: Layout,
      children: [
        {
          path: '',
          component: AddressList,
          name: 'ShoppingCartAddress',
        },
      ],
    },
    {
      path: '/address/edit',
      component: Layout,
      children: [
        {
          path: '',
          component: AddressEdit,
          name: 'ShoppingCartAddressEdit',
        },
      ],
    },
    {
      path: '/order',
      component: Layout,
      children: [
        {
          path: '',
          component: OrderList,
          name: 'OrderList',
        },
      ],
    },
    {
      path: '/center',
      component: Layout,
      children: [
        {
          path: '',
          component: userCenter,
          name: 'userCenter',
        },
      ],
    },
    {
      path: '/account',
      component: AccountLayout,
      children: [
        {
          path: 'login',
          component: () => import('@/views/account/login'),
          name: 'Login',
        },
      ],
    },
    {
      path: '/404',
      component: Layout,
      children: [
        {
          path: '',
          component: () => import('@/views/error-page/404'),
          name: 'WrongUrl',
        },
      ],
    },
    // 404 page must be placed at the end
    { path: '*', redirect: '/404' },
  ],
})
